import { NgModule } from '@angular/core';
import { SharedModule } from './shared.module';
import { PdqComponent } from '../components/ehr/pdq/pdq.component';
import { Pdqiti21Component } from '../components/ehr/pdq/pdqiti21/pdqiti21.component';
import { Pdqiti22Component } from '../components/ehr/pdq/pdqiti22/pdqiti22.component';
import { Pdqv3Component } from '../components/ehr/pdq/pdqv3/pdqv3.component';
import { PdqmComponent } from '../components/ehr/pdq/pdqm/pdqm.component';
import { StandaloneModule } from './standalone.module';

@NgModule({
  declarations: [
    PdqComponent,
    Pdqiti21Component,
    Pdqiti22Component,
    Pdqv3Component,
    PdqmComponent,
  ],
  imports: [SharedModule, StandaloneModule],
  exports: [
    PdqComponent,
    Pdqiti21Component,
    Pdqiti22Component,
    Pdqv3Component,
    PdqmComponent,
  ],
})
export class PdqModule {}
